import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import { routes, enums } from '../../../constants'
import storage from '../../../services/stoage.service'
import utils from '../../../utils'
import { actions } from '../configAilos.actions'
import { ConfigAilosForm } from './ConfigAilosForm'
import { Button } from 'primereact/button'
import { DefaultToolBar } from '../../../components/toolbar/DefaultToolBar'
import * as listPageUtils from '../../../utils/listPageContainerUtils'
import { logarAcesso } from '../../../services/api-log-acesso'

const mapStateToProps = (state) => {
  const messages = state.crudConfigAilosState.messages
  const record = state.crudConfigAilosState.currentRecord

  // REFERENTE AO DROPDOWN DE UNIDADES
  let disableUnit = false
  let unidade = null
  const currentUnit = storage.getUnit()
  if (currentUnit) {
    unidade = { id: currentUnit.oid, value: currentUnit.sigla }
    disableUnit = true
  }

  const unidades = utils.getListIdValuesUnidadeFromEmpresa(storage.getCompany())
  return {
    record,
    messages,
    unidades,
    disableUnit,
    unidade,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    paginate: (paginationParams) => dispatch(actions.paginate(paginationParams)),
    sortOrder: (sortParams) => dispatch(actions.sortOrder(sortParams)),
    applyFilter: (filterParams) => {
      dispatch(actions.setType(null))
      dispatch(actions.applyFilter(filterParams))
    },
    setField: (field, value) => dispatch(actions.setField(field, value)),
    changeHandler: (event) => {
      const target = event.target
      const field = target.name
      let valor = target.value
      dispatch(actions.removeErrors([{ field }]))
      dispatch(actions.setField(field, valor))
    },
    onClickBotaoDinamico: (listId, oidBotao) => dispatch(actions.executarFuncaoDinamica(listId, oidBotao)),
    saveHandler: (event) => dispatch(actions.save()),
    removeHandler: (event) => dispatch(actions.remove()),
    newHandler: (event) => dispatch(actions.makeNew()),
    loadById: (oid) => dispatch(actions.loadById(oid)),
    loadFavorito: (menu) => dispatch(actions.loadFavorito(menu)),
    removeFavorito: (menu) => dispatch(actions.removeFavorito(menu)),
    adicionarFavorito: (menu) => dispatch(actions.adicionarFavorito(menu)),
    getBotoesDinamicos: (idTela) => {
      let tipoTela = Number(enums.TipoTela.FORMULARIO)
      dispatch(actions.getBotoesDinamicos(idTela, tipoTela))
    },
    configurarContaAilos: (unidade) => dispatch(actions.configurarContaAilos(unidade)),
    showWarningMessage: (message) => dispatch(actions.showWarningMessage(message)),
  }
}

class ConfigAilosFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.showPesquisarButton = false
    this.showCSVButton = false
    this.showColumnButton = false
    this.state = {
      dadosFavorito: null,
      favorito: 0,
      unidade: this.props.unidade,
    }
    actions.afterNew = () => {
      this.props.history.push(`${routes.PATH_CONFIG_AILOS}`)
    }
    actions.afterLoadFavorito = (data) => {
      if (data && data.oid) {
        this.setState({ favorito: 1 })
        this.setState({ dadosFavorito: data })
      } else {
        this.setState({ favorito: 0 })
        this.setState({ dadosFavorito: null })
      }
    }
  }

  componentDidMount() {
    logarAcesso().then()
    this.props.newHandler()
    this.props.loadFavorito(this.props.history.location.pathname)
  }

  loadFavorito() {
    listPageUtils.loadFavorito(this, actions)
  }

  changeFavorito() {
    listPageUtils.changeFavorito(this, actions)
  }

  configurarIntegracao = () => {
    if (this.state.unidade && this.state.unidade.id) {
      this.props.configurarContaAilos(this.state.unidade)
    } else {
      this.props.showWarningMessage('Selecione uma unidade')
    }
  }

  getCustomButtons = () => {
    return (
      <div className="p-toolbar-group-left">
        <Button
          label="Configurar"
          icon="pi pi-check"
          className="p-button-success"
          onClick={this.configurarIntegracao}
        />
      </div>
    )
  }

  onChangeUnit = (e) => {
    this.setState({ unidade: e.target.value })
  }

  buildHeader = () => {
    return (
      <div>
        <DefaultToolBar listPageContainer={this} title={'Config. Integração Ailos'} />
      </div>
    )
  }

  render() {
    const content = (
      <ConfigAilosForm
        visualizarRelatorio={this.visualizarRelatorio}
        currentUser={this.props.currentUser}
        messages={this.props.messages}
        changeHandler={this.props.changeHandler}
        record={this.props.record}
        disableUnit={this.props.disableUnit}
        unidades={this.props.unidades}
        unidade={this.state.unidade}
        onChangeUnit={this.onChangeUnit}
      />
    )

    return <Page content={content} header={this.buildHeader()} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfigAilosFormPageContainer)
